import {getNamesFromArray} from "@/utils/formData";

export default {
  countCells: 6,
  massive: [
    {
      dataField: 'olympiad',
      cols: 2,
      rows: 1,
      text: 'Наименование олимпиады',
      class: 'd-flex flex-row align-start justify-start ',
      headerClass: 'justify-start ',
      headerStyles: `min-width: 260px; justify-content: flex-start;`,
      order: 0,
      variable: true,
    },
    {
      dataField: 'value',
      cols: 1,
      rows: 1,
      order: 7,
      class: `align-start`,
      headerClass: 'd-flex flex-row justify-center px-2',
      variable: true,
      text: 'Общая потребность в количестве мест на 2023/2024 учебный год по олимпиаде',
    },
    {
      dataField: 'profiles',
      cols: 2,
      rows: 1,
      order: 2,
      variable: true,
      headerClass: ' ',
      class: 'px-2 align-start',
      headerStyles: `min-width: 200px`,
      text: `Наименование профиля и потребность в количестве мест на 2023/24 учебный год по профилю`,
      template: (r)=> getNamesFromArray(r?.profiles,['name', 'value'], '<br/>')
    },
    {
      dataField: 'actions',
      cols: 1,
      rows: 1,
      order: 9,
      class: 'd-flex flex-row align-start justify-center ',
      headerClass: '',
      variable: true,
      text: 'Редактировать',
    },

  ]
}
